import { filter, map, Observable, of } from 'rxjs';
import notNullish from '@tv2/lib-core/notNullish';
import { record } from '../util/vcr';
import { UnifiedPlayer } from '../types';
import type * as Epg from './dataProviders/Epg';
import type * as Tracking from './dataProviders/Tracking';
import { makeMediaObservable$, UseTrackingProps } from '../plugins/Tracking';

// The VCR Plugin enabled recording of the player timeline. You can download it using window.vcr.download(). This is useful for debugging.
export function vcrPlugin(
  epgOptions: UseTrackingProps['epgOptions'],
  dependencies: { Epg: typeof Epg; Tracking: typeof Tracking },
  includeStartOverInformation: boolean = false
) {
  let recorder: any;

  const plugin = (_media$: Observable<any>, player: UnifiedPlayer) => {
    const { Epg, Tracking } = dependencies;
    // Records the player timeline. You can download it using window.vcr.download(). This is useful for debugging.
    const media$ = makeMediaObservable$(player);

    const nielsenTrackingV2 = '2';

    const epgPoll$ = Epg.poll$(media$ as any, epgOptions, includeStartOverInformation);
    const trackingPoll$ = Tracking.poll$(media$ as any, epgOptions, nielsenTrackingV2).pipe(
      filter(x => Boolean(x.liveTrackingResult)),
      map(x => x.liveTrackingResult),
      filter(notNullish)
    );

    recorder = record(of(player), media$, epgPoll$, trackingPoll$);
    // eslint-disable-next-line no-console
    console.log('VCR', "Recording player's timeline, use window.vcr.download() to download it.");
  };

  plugin.destroy = () => {
    if (recorder) {
      recorder.destroy();
    }
  };

  return plugin;
}
